module.exports = __webpack_public_path__ + "static-v-shop/1786392158156/img/banner-desktop.c46aa3b3.png";